import { render, staticRenderFns } from "./Restoring.vue?vue&type=template&id=30d61de0&"
import script from "./Restoring.vue?vue&type=script&lang=js&"
export * from "./Restoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports